import { Component } from '@angular/core';
import { Auth } from './services/auth';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterLink, FormsModule, ReactiveFormsModule,  MatSnackBarModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App  {

  //router = Inject(Router);
  constructor( private auth: Auth, private router: Router  ) {} 

  protected title = 'activeturf';

  calendarYear = new Date().getFullYear();

  onLogout(): void{
    if (this.auth.isLoggedIn()){
      this.auth.logout();
    }     
    this.router.navigate(['/']);
  }
 /*  ngOnInit(): void {
    
  if (!this.auth.isLoggedIn())
  {
    this.router.navigate(['/login']);
  } */
  }

